import { useEffect } from 'react';
import type { Video as VideoType } from 'types/capi/content';

import useEnv from '~/hooks/useEnv';
import sdks from '~/utils/sdks';

const Video = ({ video }: { video: VideoType }) => {
  switch (video.site) {
    case 'youtube':
      return <YouTubeVideo id={video.id} />;
    case 'vimeo':
      return <VimeoVideo video={video} />;
    case 'facebook':
      return <FacebookVideo url={video.url} />;
    default:
      return null;
  }
};

const YouTubeVideo = ({ id }: { id: VideoType['id'] }) => {
  const embedUrl = `https://www.youtube.com/embed/${id}?playsinline=1`;

  return (
    <iframe
      className="aspect-video w-full"
      title="youtube-video"
      loading="lazy"
      allowFullScreen={true}
      aria-label="video"
      src={embedUrl}
      allow="autoplay;encrypted-media;gyroscope;picture-in-picture;"
    />
  );
};

const VimeoVideo = ({ video }: { video: VideoType }) => {
  const { id, loop, autoplay } = video;
  const src = `https://player.vimeo.com/video/${id}?autoplay=${
    autoplay ? '1' : '0'
  }&loop=${loop ? '1' : '0'}&background=${autoplay ? '1' : '0'}`;

  return (
    <iframe
      className="aspect-video w-full"
      title="vimeo-video"
      src={src}
      allow="autoplay; fullscreen"
      aria-label="video"
      allowFullScreen
    />
  );
};

const FacebookVideo = ({ url }: { url: VideoType['url'] }) => {
  const { FACEBOOK_APP_ID } = useEnv();

  useEffect(() => {
    sdks.injectFacebook(FACEBOOK_APP_ID);
  }, [FACEBOOK_APP_ID]);

  if (!url) return null;

  return (
    <>
      <div id="fb-root" />
      <div className="w-full" data-href={url} data-allowfullscreen="false" />
    </>
  );
};
export default Video;
